
































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { IPublicUserObject, IUserReviewObject } from '../../../../../shared/types';

import api from '../../../api';
import ReviewForm from './review-form.vue';

interface IData {
  review: IUserReviewObject | null;
  mode: number;
  rating: number;
  name: string;
  description: string;
}

interface IMethods {
  findingReview: () => Promise<void>;
  changeRating: (index: number) => void;
  toggleMode: () => void;
  save: () => Promise<void>;
  removeReview: () => Promise<void>;
  goToUser: () => void;
  goToReview: () => void;
}

interface IComputed {
  getUser: IPublicUserObject;
  actionText: string;

}

interface IProps {
  showId: number;
  userId: number;
}

export default Vue.extend<IData, IMethods, IComputed, IProps>({
  name: 'UserReview',

  components: {
    ReviewForm,
  },

  props: {
    showId: {
      type: Number,
      required: true,
    },

    userId: {
      type: Number,
      required: true,
    },
  },

  data: () => ({
    review: null as IUserReviewObject | null,
    mode: 0,
    rating: 0,
    name: '',
    description: '',
  }),

  created() {
    this.findingReview();
  },

  methods: {
    async findingReview() {
      const reviews = await api.review.getUserReviews(this.userId);

      for (let i = 0; i < reviews.length; i += 1) {
        const review = reviews[i];

        if (review.showId === this.showId) {
          this.review = review;
          this.rating = review.rating;
          this.name = review.name;
          this.description = review.description;
          this.$emit('found');
          break;
        }
      }
    },

    changeRating(index: number) {
      if (this.mode === 1) {
        this.rating = index;
      }
    },

    toggleMode() {
      if (this.mode) {
        this.save();
      } else if (this.review) {
        this.rating = this.review.rating;
        this.name = this.review.name;
        this.description = this.review.description;
      }
      this.mode = this.mode === 1 ? 0 : 1;
    },

    async save() {
      if (this.review) {
        await api.review.edit(
          this.review.id as unknown as number,
          this.name,
          this.rating,
          this.description,
        );
      }

      this.findingReview();
    },

    async removeReview() {
      if (this.review) {
        await api.review.deleteOne(this.review.id as number);
      }
      this.review = null;
    },

    goToUser() {
      this.$router.push(`/profile/${this.userId}`);
    },

    goToReview() {
      this.$router.push(`/review/${this.showId}/${this.review !== null ? this.review.id : 0}`);
    },
  },

  computed: {
    ...mapGetters('user', [
      'getUser',
    ]),

    actionText() {
      return this.mode === 0 ? 'Edit' : 'Save';
    },
  },
});
